// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    accessRequestsUrl: 'https://devaccessrequestinbox.socialboards.com/',
    apiAuthUrl: 'https://devauthapi.socialboards.com/',
    apiFaqUrl: 'https://devfaqapi.socialboards.com/api/',
    apiFormUrl: 'https://devformapi.socialboards.com/api/',
    apiInboxUrl: 'https://devinboxapi.socialboards.com/api/',
    apiMasterUrl: 'https://devmasterapi.socialboards.com/api/',
    apiMicrosoftDynamicsUrl: 'https://devappsapi.socialboards.com/api',
    apiVersion: '8',
    appInsightsId: '665366cf-566c-4218-a133-8ddf807e5e66',
    appInsightsWidgetId: '882f9c67-fddc-4480-ab70-f79c2fa3d6ab',
    dynamicsUrl: 'https://devmicrosoftdynamics365app.socialboards.com',
    environment: 'development',
    faqIframeUrl: 'https://deviframes.socialboards.com/faq/',
    faqUrl: 'https://devfaq.socialboards.com/',
    formUrl: 'https://devform.socialboards.com/',
    gaGlobalTrackerId: 'UA-72837935-1',
    inboxUrl: 'https://devinbox.socialboards.com',
    isLocalhost: false,
    isNoNeedInCommunicator: false,
    loginAppUrl: 'https://devlogin.socialboards.com/',
    magicWidgetApiUrl: 'https://devmagicwidgetapi.socialboards.com/api/',
    magicWidgetUrl: 'https://devmagicwidget.socialboards.com',
    masterUrl: 'https://devmasterapi.socialboards.com/',
    outlookAddinUrl: 'https://devoutlookaddin.socialboards.com',
    production: false,
    settingsUrl: 'https://devsettings.socialboards.com/',
    signalrServerUrl: '',
    tiktokClientKey: '7387586562210398225',
    uploadsUrl: 'https://devuploads.socialboards.com/api/',
    youtubeClientId: '487155496101-k1ob3a3j6irtpusj85d04cgc6jrnu7h6.apps.googleusercontent.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error',  // Included with Angular CLI.
